// Détecte si la base locale Dexie ne contient qu'UN SEUL "vrai" customer
// (hors clients fictifs KTM_xxx et PROSPECT_xxx).
//
// Quand vrai : on verrouille la sélection (le user est sur ce client, il
// ne peut ni le quitter ni changer de tarif ; on masque aussi la config
// des tarifs offline). Couple auto-select au login via
// useSales.autoSelectSingleCustomer().
//
// Source unique : useLiveQuery sur db.customers → réactif aux syncs.

import { useLiveQuery } from 'dexie-react-hooks'
import { db } from '../stores/db'
import glob_const from '../libs/glob_const'

export default function useIsSingleCustomerLocal(): boolean {
   const count = useLiveQuery(async () => {
      const all = await db.customers.toCollection().toArray()
      return all.filter(c =>
         !c.id.startsWith(glob_const.prefix_ktm) &&
         !c.id.startsWith(glob_const.prefix_prospect),
      ).length
   }, [], 0)
   return count === 1
}
